<template>
  <b-row>
    <b-col
      md="7"
      sm="12"
    >
      <buscador :data="dependenciaSugerida" />
      CRUD Dependencias
    </b-col>
    <b-col
      md="5"
      sm="12"
    >
      <dependencia-sugerida @set-data="dependenciaSugerida = $event" />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import DependenciaSugerida from './components/dependencia/DependenciaSugerida.vue'
import Buscador from './components/dependencia/Buscador.vue'

export default {
  components: {
    BRow,
    BCol,
    DependenciaSugerida,
    Buscador,
  },
  setup() {
    const dependenciaSugerida = ref({})

    return {
      dependenciaSugerida,
    }
  },
}
</script>
